<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'ProductCategoryContainer',
        components: {
        },
        mounted() {
        },
        data () {
            return {
                Core: window.Core
            }
        },
        methods: {
            add() {
                if (this.$route.fullPath === window.Core.Definition.getDefinition('/commerce/produits/categories/nouvelle-categorie')) {
                    location.reload()
                } else {
                    this.$router.push(window.Core.Definition.getDefinition('/commerce/produits/categories/nouvelle-categorie'))
                }
            }
        }
    }
</script>
